import React from 'react';

interface MetricCardProps {
  icon: string;
  label: string;
  value: string | number;
  trend?: string;
  color?: string;
  subtitle?: string;
  loading?: boolean;
}

const MetricCard: React.FC<MetricCardProps> = ({
  icon,
  label,
  value,
  trend,
  color = '#006175',
  subtitle,
  loading = false
}) => {
  const getTrendColor = () => {
    if (!trend) return 'text-muted';
    if (trend.startsWith('+')) return 'text-success';
    if (trend.startsWith('-')) return 'text-danger';
    return 'text-muted';
  };

  const getTrendIcon = () => {
    if (!trend) return '';
    if (trend.startsWith('+')) return 'bx-trending-up';
    if (trend.startsWith('-')) return 'bx-trending-down';
    return '';
  };

  return (
    <div className="card border-0 shadow-sm h-100">
      <div className="card-body">
        <div className="d-flex align-items-center">
          <div className="flex-grow-1">
            <p className="text-muted mb-1 fw-medium small">{label}</p>
            {loading ? (
              <div className="spinner-border spinner-border-sm text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            ) : (
              <>
                <h3 className="mb-0 fw-bold" style={{ color }}>
                  {value}
                </h3>
                {trend && (
                  <small className={getTrendColor()}>
                    <i className={`bx ${getTrendIcon()} me-1`}></i>
                    {trend}
                  </small>
                )}
                {subtitle && (
                  <div className="mt-1">
                    <small className="text-muted">{subtitle}</small>
                  </div>
                )}
              </>
            )}
          </div>
          <div className="flex-shrink-0">
            <div
              className="avatar-lg rounded-circle d-flex align-items-center justify-content-center"
              style={{ backgroundColor: `${color}20` }}
            >
              <i className={`bx ${icon} font-size-24`} style={{ color }}></i>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MetricCard;

